var render, staticRenderFns
import script from "./WidgetSkeleton.vue?vue&type=script&lang=ts&"
export * from "./WidgetSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetSkeleton.vue?vue&type=style&index=0&id=7dc17fdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports